export class BaseRoutingStrategy {
  constructor(apiKey) {
    this.apiKey = apiKey;
  }

  async geocodeWaypoints(waypoints) {
    throw new Error('geocodeWaypoints() must be implemented');
  }

  async calculateRoute(options) {
    throw new Error('calculateRoute() must be implemented');
  }

  async geocodeAddress(address) {
    throw new Error('geocodeAddress() must be implemented');
  }

  initAutocomplete(inputElement, onPlaceSelected) {
    throw new Error('initAutocomplete() must be implemented');
  }

  initOriginAutocomplete(inputElement, onPredictionsUpdated) {
    throw new Error('initOriginAutocomplete() must be implemented');
  }

  initDestinationAutocomplete(inputElement, onPredictionsUpdated) {
    throw new Error('initDestinationAutocomplete() must be implemented');
  }

  selectPrediction(prediction) {
    throw new Error('selectPrediction() must be implemented');
  }

  buildDeepLink(waypoints, options = {}) {
    throw new Error('buildDeepLink() must be implemented');
  }

  preloadApi() {
  }
}
